"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var form_control_1 = require("@prezzee/form-control");
var style = __importStar(require("./NotchedOutline.style"));
function NotchedOutline(_a) {
    var children = _a.children, className = _a.className, label = _a.label, notched = _a.notched, rest = __rest(_a, ["children", "className", "label", "notched"]);
    var formControl = (0, form_control_1.useFormControl)();
    var withLabel = label != null && label !== '';
    return ((0, jsx_runtime_1.jsx)("fieldset", __assign({ "aria-hidden": true, className: className }, rest, { css: style.fieldset(!!formControl.error, Boolean(formControl.focused)) }, { children: (0, jsx_runtime_1.jsx)("legend", __assign({ css: style.legend(Boolean(formControl.focused || formControl.filled || notched)) }, { children: withLabel ? (0, jsx_runtime_1.jsx)("span", { children: label }) : (0, jsx_runtime_1.jsx)("span", __assign({ className: "notranslate" }, { children: "\u200B" })) })) })));
}
exports.default = NotchedOutline;
//# sourceMappingURL=NotchedOutline.js.map